import { isPdiRetailTenant } from "../../../core/utils"
import { TunnelDataContext } from "../../../digital-journey/context/TunnelDataContext"
import React, { useContext } from "react"

const RetailLogoWrapper = ({ children }) => {
  const { tunnelData } = useContext(TunnelDataContext)

  const handleRetailBackToHome = () => {
    window.location.href = isPdiRetailTenant(tunnelData?.tenant) ? `${tunnelData?.pdiRetailUrl}?tenant=${tunnelData?.tenant}` : `${tunnelData?.pdiRetailUrl}`
  }

  return (
    <span onClick={tunnelData.isJourneyResumedAtHome ? null : () => handleRetailBackToHome()}>
      {children}
    </span>
  )
}

export default RetailLogoWrapper
